import { isNull, isString, isUndefined } from '@borg/utils';

/**
 * Translates given date-ish value (from backend api)
 *
 * @param value
 */
export function toDate(value: Date | string | null | undefined) {
  if (isNull(value) || isUndefined(value)) {
    return null;
  } else if (isString(value)) {
    if (!isNaN(Date.parse(value))) {
      return new Date(value);
    }
  } else {
    return value;
  }

  console.warn('Invalid date string provided', value);
  return null;
}

/**
 * Returns local date in YYYY-MM-DD format or null if that is provided, to be used in backend api
 *
 * @param input Date
 */
export const getLocaleDate = (input: Date | null) =>
  isNull(input)
    ? input
    : `${input.getFullYear()}-${(input.getMonth() + 1).toString().padStart(2, '0')}-${input
        .getDate()
        .toString()
        .padStart(2, '0')}`;
